export default __webpack_public_path__ + "static/SRF Carasweet 5SGF7709 - Fiche de spécifications et données techniques-7e39d8aa156dde55b70d5519212cbc4e.pdf";